import React from 'react'
import { PropTypes } from 'prop-types'

class EmployerRow extends React.Component {
  constructor(props) {
    super(props)
    this.handleRowClick = this.handleRowClick.bind(this)
  }

  handleRowClick(e) {
    e.preventDefault()
    this.props.onSelect(this.props.employer)
  }

  render() {
    const addDomainButton = <button className='ln-c-button ln-c-button--text' style={{ paddingLeft: '0rem' }} role='button' onClick={this.handleRowClick}>Add company email domain</button>
    
    let domainList = ''
    if (this.props.employer.allowedDomains !== null) {
      domainList = this.props.employer.allowedDomains.split(',').join(', ')
    }
    
    return (
      <tr className='ln-c-table__row' style={{ height: '4rem' }}>
        <td className='ln-c-table__cell'>
          {(new Date() - new Date(this.props.employer.addedAt)) < (120 * 120 * 1000) ?
            <div
              className='c-badge c-badge--secondary c-badge--inverted'
              style={({ border: '1px solid', marginRight: this.props.employer.active ? '20px' : '10px' })}
            >New</div> : ''}
          {!this.props.employer.active ?
            <div
              className='c-badge c-badge--secondary c-badge--inverted o-generic--inactive-badge-alignment'
            >Inactive</div> : ''}
          <a
            href={`/employers/${this.props.employer.id}#tab-details`}
            onClick={this.handleRowClick}
          >{this.props.employer.name}</a>
        </td>
        <td className='ln-c-table__cell'>{this.props.employer.code}</td>
        <td className='ln-c-table__cell'>{this.props.employer.emailAddress}</td>
        <td className='ln-c-table__cell noWordWrap'>{ this.props.employer.allowedDomains === null ? addDomainButton : domainList }</td>
      </tr>
    )
  }
}

EmployerRow.propTypes = {
  onSelect: PropTypes.func.isRequired,
  employer: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    code: PropTypes.string,
    emailAddress: PropTypes.string,
    active: PropTypes.bool,
    addedAt: PropTypes.string,
    allowedDomains: PropTypes.oneOfType([
      PropTypes.string,
      null
    ])
  }).isRequired
}

export default EmployerRow


// WEBPACK FOOTER //
// ./src/components/EmployerGrid/EmployerRow/index.jsx